import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { AssetsUrlPipe } from '../../../pipes/assets-url.pipe';
import { UpaAsyncService } from '../../../services/upa-async.service';
import { redirectToUrl } from '../utils/navigation.utils';
import { IFOOD_URL } from '../utils/urls.constants';

@Component({
  selector: 'al-header-landing',
  standalone: true,
  imports: [CommonModule, AssetsUrlPipe],
  templateUrl: './header-landing.component.html',
  styleUrls: ['./header-landing.component.scss']
})
export class HeaderLandingComponent {
  @Input() isResolutionMobile = false;
  @Input() isClientNotEnrolled = false;
  @Input() isEnrolled = false;
  @Input() isClient = false;
  @Input() source = '';


  upaAsyncService = inject(UpaAsyncService);

  getLandingText(): { main: string; linea1: string; linea2: string } {
    if (!this.isEnrolled && !this.isClient) {
      return {
        main: 'Mais de 2 milhões de pessoas já conectaram',
        linea1: 'Ganhe pontos Passaporte',
        linea2: 'a cada pedido que fizer no iFood',
      };
    }

    if (this.isEnrolled) {
      return {
        main: 'Mais de 2 milhões de pessoas já estão aproveitando',
        linea1: 'Bora transformar seus pontos',
        linea2: 'em novas aventuras?',
      };
    }

    if (this.isClient) {
      return {
        main: 'Mais de 40 mil pessoas já estão aproveitando',
        linea1: 'Decolar + iFood: até 25% OFF',
        linea2: 'para você viajar',
      };
    }

    return { main: '', linea1: '', linea2: '' };
  }

  onConnectIfoodClick(from = 'main') {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        `connect_ifood_${from}`,
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();

    redirectToUrl(IFOOD_URL);
  }
}
